import React from 'react'
import { FormRenderProps } from 'react-final-form'
import checkPermission from '../../../../../../utilities/checkPermission'
import * as resultOfConsiderPreviousType from './resultOfConsiderPreviousType'
import _ from 'lodash'
import { DialogType } from '../../../../../../control/dialog/dialog'
import useTranslate from '../../../../../../i18n/useTranslate'
import useWebService from '../../../../../../services/web/useWebService'
import useLookupService from '../../../../../../services/lookup/useLookupService'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import { InitialRichTextEditorType } from '../../../../../../control/richTextEditor/richTextEditor'
import constSubmittedType from '../../../../../../constants/submittedType'
import constConsiderType from '../../../../../../constants/considerType'
import {
    ResultCertificateCloseProjectResponse,
    SynthesisReviewResultType,
} from '../../../../../../services/web/types/responseWebServiceTypes'

const useResultOfConsiderPrevious = (props: resultOfConsiderPreviousType.UseResultOfConsiderPreviousType) => {
    const { submittedID } = props
    const callWebService = useWebService()
    const checkPermissionHook = checkPermission()
    const translate = useTranslate()
    const manageProjectStore = useManageProjectStore()
    const projectData = manageProjectStore.projectData

    const [initialValues, setInitialValues] = React.useState<any>({})
    const [required, setRequired] = React.useState<boolean>(true)

    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const formRef = React.useRef<FormRenderProps>()
    const callLookup = useLookupService()

    const [initialSuggestionNotice, setInitialSuggestionNotice] = React.useState<InitialRichTextEditorType>()

    React.useEffect(() => {
        if (projectData) {
            createInitialData()
        }

        if (projectData?.considerInfo && projectData?.considerInfo?.value) {
            setRequired(projectData?.considerInfo?.value === constConsiderType.exempt ? false : true)
        }
    }, [projectData?.projectID ?? null, projectData?.submittedID ?? null, projectData?.considerInfo ?? null])

    const getMemoMessage = async () => {
        if (submittedID) {
            const { result } = await callWebService.getCertificateCloseProject(submittedID)
            return result
        }
    }

    const getSynthesisReviewData = async () => {
        if (submittedID) {
            const { result } = await callWebService.getSynthesisReview(submittedID)
            return result
        }
    }

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    /**
     * Default value form
     */
    const createInitialData = async () => {
        const result = await getMemoMessage()
        const resultSynthesisReview = await getSynthesisReviewData()
        if (result) {
            const initialData = {
                memoMessageDate: result.memoMessageCommentDate ? new Date(result.memoMessageCommentDate) : new Date(),
                approveStatus:
                    result && result?.approveStatusInfo
                        ? {
                              label:
                                  translate.languageStore.currentLanguage === translate.languageKey.th
                                      ? result.approveStatusInfo.nameTH
                                      : result.approveStatusInfo.nameEN,
                              value: result?.approveStatusInfo.value.toString(),
                          }
                        : null,
            }

            /******* SuggestionNotice ********/
            const initialSugestionNotice = createInitialSuggestion(resultSynthesisReview)

            /******set state *******/
            setInitialValues(initialData)
            setInitialSuggestionNotice(initialSugestionNotice)
        }
    }

    /**
     * SuggestionNotice
     */

    const createInitialSuggestion = (content?: SynthesisReviewResultType) => {
        const initialSugestionNotice = {
            contentHtml: content?.synthesisReviewRemarkInfo.synthesisReviewRemark_html ?? '',
            contentText: content?.synthesisReviewRemarkInfo.synthesisReviewRemark ?? '',
        }
        return initialSugestionNotice
    }

    return {
        formRef,
        configDialog,
        isViewMode: isViewMode,
        initialValues,
        initialSuggestionNotice,
        required,
        onRefDialog,
    }
}

export default useResultOfConsiderPrevious
